export class UIDisableReason {
    public static readonly SPIN_RESPONSE: symbol = Symbol('SPIN_RESPONSE');
    public static readonly QUICK_STOP: symbol = Symbol('QUICK_STOP');
    public static readonly TRIGGERING_FEATURE: symbol = Symbol('TRIGGERING_FEATURE');
    public static readonly SPINNING: symbol = Symbol('SPINNING');
    public static readonly AUTOPLAY_MODE: symbol = Symbol('AUTOPLAY_MODE');
    public static readonly RESPIN_MODE: symbol = Symbol('RESPIN_MODE');
    public static readonly FREE_SPIN_MODE: symbol = Symbol('FREE_SPIN_MODE');
    public static readonly OPENNED_POPUP: symbol = Symbol('OPENNED_POPUP');
    public static readonly WAITING: symbol = Symbol('WAITING');
    public static readonly PROMOTION: symbol = Symbol('PROMOTION');
    public static readonly ROUND_DELAY: symbol = Symbol('ROUND_DELAY');
    public static readonly DISABLED_QUICK_STOP: symbol = Symbol('DISABLED_QUICK_STOP');
}
